import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { NotificationDataObject } from 'models/service';

type GetNotificationsParameters = {
  cursor?: string;
  limit?: number;
};

export const getNotifications = async ({ config: { params } }: ConfigRequest<GetNotificationsParameters>) =>
  apiClient.get<NotificationDataObject[], ApiClientResponse<NotificationDataObject[]>>(routes.notifications.find, {
    params,
  });
